export default "__VITE_ASSET__Bx3br3Qs__"